import { ChamferFeature } from '@kb3d/models/classes/features/chamfer-feature';
import { Token } from '@kb3d/models/classes/token';
import { FeatureRenderer } from './feature';
import { ChamferGeometryProcessor } from './geometry-processor/chamfer-geometry';

export class ChamferFeatureRenderer extends FeatureRenderer<ChamferFeature> {
    modelToken = Token.ChamferFeature;
    processor = new ChamferGeometryProcessor(this.scene);
    update3dInternal() { }
}